import React from "react";
import { Box, Container, Grid, List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import PageBanner from "../../components/PageBanner";
import CTASection from "../../components/CTASection";

const Service = ({ service }) => (
  <>
    <PageBanner
      title={service.title}
      description={service.intro}
      image={service.heroImage}
      breadcrumbs={[
        { label: "Services", to: "/services" },
        { label: service.title },
      ]}
    />

    <Box className="site-section">
      <Container>
        <Grid container spacing={{ xs: 4, md: 4.5, lg: 5 }} alignItems="start" sx={{ width: "100%", m: 0 }}>
          <Grid item xs={12} lg={7}>
            <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 800 }}>
              {service.eyebrow}
            </Typography>
            <Typography variant="h2" sx={{ mt: 1.25, maxWidth: 760 }}>
              {service.title}
            </Typography>
            <Box sx={{ mt: 3 }}>
              {service.paragraphs.map((paragraph) => (
                <Typography
                  key={paragraph}
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 2.2, maxWidth: 720, lineHeight: 1.9 }}
                >
                  {paragraph}
                </Typography>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box
              component="img"
              src={service.sideImage}
              alt={service.title}
              loading="lazy"
              decoding="async"
              sx={{
                width: "100%",
                aspectRatio: "4 / 3",
                objectFit: "cover",
                borderRadius: "var(--radius-panel)",
                border: "1px solid var(--color-border)",
                boxShadow: "var(--shadow-card)",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>

    <Box className="site-section site-section--white">
      <Container>
        <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                height: "100%",
                p: { xs: 2.8, md: 3.3 },
                borderRadius: "var(--radius-card)",
                border: "1px solid var(--color-border)",
                boxShadow: "var(--shadow-card)",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Key Areas
              </Typography>
              <List disablePadding>
                {service.keyPoints.map((item) => (
                  <ListItem key={item} disableGutters sx={{ py: 0.9 }}>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{ color: "text.secondary", lineHeight: 1.7 }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                height: "100%",
                p: { xs: 2.8, md: 3.3 },
                borderRadius: "var(--radius-card)",
                border: "1px solid var(--color-border)",
                boxShadow: "var(--shadow-card)",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Related Services
              </Typography>
              <List disablePadding>
                {service.supportAreas.map((item) => (
                  <ListItem key={item} disableGutters sx={{ py: 0.9 }}>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{ color: "text.secondary", lineHeight: 1.7 }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>

    <CTASection
      title={`Discuss ${service.title}`}
      description={`For formal inquiries regarding ${service.title.toLowerCase()}, please use Refwa's listed contact details.`}
      primaryLabel="Contact Refwa"
      primaryTo="/contact"
      secondaryLabel="Explore Services"
      secondaryTo="/services"
    />
  </>
);

export default Service;
